export default __webpack_public_path__ + "static/media/nextArrow.ed766093.svg";